import { Component, OnInit } from '@angular/core';
import { loadScript } from '@paypal/paypal-js';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-product-info',
  templateUrl: './product-info.component.html',
  styleUrls: ['./product-info.component.scss'],
})
export class ProductInfoComponent implements OnInit {
  tableId = 't-payment-history';
  display: boolean = false;
  paypal;

  constructor() {}

  ngOnInit() {
    this.initPaypal();
  }

  handleMakePayment(e) {
    this.display = true;
  }

  generatePaypalButton() {
    if (!this.paypal) {
      console.log('Paypal script instance is not initialized');
      return;
    }

    this.paypal
      .Buttons({
        style: {
          shape: 'rect',
          color: 'gold',
          layout: 'vertical',
          label: 'paypal',
        },

        createOrder: function (data, actions) {
          return actions.order.create({
            purchase_units: [
              {
                description: 'AutoBCM Subcription',
                amount: { currency_code: 'USD', value: '9' },
              },
            ],
          });
        },

        onApprove: function (data, actions) {
          return actions.order.capture().then(function (orderData) {
            // Full available details
            console.log(
              'Capture result',
              orderData,
              JSON.stringify(orderData, null, 2)
            );

            // Or go to another URL:  actions.redirect('thank_you.html');
          });
        },

        onError: function (err) {
          console.log(err);
        },
      })
      .render('#paypal-button')
      .catch((error) => {
        console.error('failed to render the PayPal Buttons', error);
      });
  }

  initPaypal() {
    loadScript({
      'client-id':
        'AWqYvo8Ca1DnQ9u_JxPGyAyGl_PAoFER46hMNIdtkwo-yOWKOJD5xHzOUC0t2uoSGsy2JEijtTwlQU8P',
    })
      .then((paypal) => {
        this.paypal = paypal;
      })
      .catch((error) => {
        console.error('failed to load the PayPal JS SDK script', error);
      });
  }
}
